import { render, staticRenderFns } from "./ExhibitorResource.vue?vue&type=template&id=462edbe0&"
import script from "./ExhibitorResource.vue?vue&type=script&lang=js&"
export * from "./ExhibitorResource.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorResource.vue?vue&type=style&index=0&id=462edbe0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports